var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialProfilesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1602 3.74994C14.1602 3.30259 14.5228 2.93994 14.9702 2.93994C17.9028 2.93994 20.2802 5.31731 20.2802 8.24994C20.2802 11.1826 17.9028 13.5599 14.9702 13.5599C14.5228 13.5599 14.1602 13.1973 14.1602 12.7499C14.1602 12.3026 14.5228 11.9399 14.9702 11.9399C17.0081 11.9399 18.6602 10.2879 18.6602 8.24994C18.6602 6.21201 17.0081 4.55994 14.9702 4.55994C14.5228 4.55994 14.1602 4.19729 14.1602 3.74994Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1602 12.7499C14.1602 12.3026 14.5228 11.9399 14.9702 11.9399C19.5596 11.9399 23.2802 15.6605 23.2802 20.2499C23.2802 20.6973 22.9175 21.0599 22.4702 21.0599C22.0228 21.0599 21.6602 20.6973 21.6602 20.2499C21.6602 16.5552 18.6649 13.5599 14.9702 13.5599C14.5228 13.5599 14.1602 13.1973 14.1602 12.7499Z",
    fill: "#146EB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7207 8.25C3.7207 5.35051 6.07121 3 8.9707 3C10.0861 3 11.1203 3.34786 11.9707 3.94102C12.0874 4.02243 12.2007 4.10846 12.3102 4.19884C13.477 5.16177 14.2207 6.61903 14.2207 8.25C14.2207 9.44813 13.8194 10.5525 13.1438 11.4361C13.1272 11.4577 13.1105 11.4792 13.0936 11.5006C12.7736 11.906 12.395 12.263 11.9707 12.559L11.9675 12.5612L11.9707 12.5624C12.0177 12.5808 12.0645 12.5995 12.111 12.6187C12.5756 12.8101 13.0188 13.0426 13.4362 13.3118C13.4892 13.346 13.5419 13.3808 13.5941 13.4162C15.588 14.7678 16.959 16.9691 17.1871 19.5C17.1877 19.5066 17.1883 19.5132 17.1888 19.5199C17.2099 19.7604 17.2207 20.004 17.2207 20.25C17.2207 20.6642 16.8849 21 16.4707 21H1.4707C1.05649 21 0.720703 20.6642 0.720703 20.25C0.720703 16.7508 2.89918 13.7605 5.97386 12.5612C4.61197 11.6127 3.7207 10.0354 3.7207 8.25Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialProfilesActive);
export default __webpack_public_path__ + "static/media/social-profiles-active.0740863df914fa801c8638aedce0c2c4.svg";
export { ForwardRef as ReactComponent };